import React from "react";
import { THUMBNAIL_STYLE } from "../constants/constants";

interface ThumbnailImageProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const ThumbnailImage: React.FC<ThumbnailImageProps> = ({
  src,
  alt,
  style = {},
  onError,
}) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.style.display = "none";
    onError?.(e);
  };

  return (
    <img
      src={src}
      alt={alt}
      style={{ ...THUMBNAIL_STYLE, ...style }}
      onError={handleError}
    />
  );
};

export default ThumbnailImage;
